module.exports = __webpack_public_path__ + "img/21_newYouth_wcx.ec666724.png";